import { County } from "src/assets/data/Counties";
import { ListOption } from "src/app/shared/models";

export enum TreatmentType {
  MentalHealth = 1,
  Prevention = 2,
  SubstanceUse = 3,
  DropOff = 4,
  CrisisCenters = 5,
  _211Resources = 6,
  VAMedicalCenter = 7, // removed
  HealthServies = 8,
  SupportGroups = 9,
}

export interface TreatmentProvider {
  legalName: string;
  address: string;
  city: string;
  commonName: string;
  county: string;
  deleted: boolean;
  id: number;
  latitude: number;
  longitude: number;
  medicationOfferedOrAllowed: string;
  misc: string;
  phone: string;
  servicesOffered: string;
  demographic: string;
  state: string;
  type: number;
  website: string;
  zip: string;
  payerSource: string;
}

export interface ServiceKeyword { keyword: string; code?: string; }
export type ServiceOption = ListOption<ServiceKeyword[]>;

export type DemographicOption = ListOption<string[]>;

export type PayerSourceOption = ListOption<string>; // { label: string, value: string }

export interface TreatmentProviderFilterData {
  address: string;
  range: number;
  county?: County;
  latitude?: number;
  longitude?: number;
  agencyType?: TreatmentType;
  servicesOffered?: ServiceOption[];
  demographics?: DemographicOption[];
  payerSources?: PayerSourceOption[];
}

export interface TreatmentProviderSearchQuery {
  Address: string;
  Latitude?: number;
  Longitude?: number;
  County?: County;
  Range?: number;
  TreatmentType?: number;
  ServicesOffered?: string[];
  Demographics?: string[];
  PayerSources?: string[];
}

export interface _211ProviderSearchQuery {
  Address: string;
  Range: number;
  County?: County;
  Latitude?: number;
  Longitude?: number;
  ServicesOffered: ServiceKeyword[];
  // Demographics: string[] | null;
  TreatmentType?: number;
}
